import type {Key} from '@react-types/shared';
import type {TabListState} from '../../@react-stately/tabs';

export const tabsIds = new WeakMap<TabListState<unknown>, string>();

export function generateId<T>(state: TabListState<T>, key: Key, role: string) {
  const compactKey = typeof key === 'string' ? key.replace(/\s+/g, '') : key;
  const baseId = tabsIds.get(state);
  return `${baseId}-${role}-${compactKey}`;
}
